module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAOCAMAAAAc7xz/AAAAAXNSR0IB2cksfwAAAD9QTFRFAAAA3+Tk3+Ll3+Pl3+Lk3+Pl3+Lm3+Pn3uLk3+Tk3+Lm3+Tm3+Ll3+Pl3+/v3+fn3+Pk3+Ll3+Pl3uPl3+PkWlhOGAAAABV0Uk5TAGDf/++AUEDwMKBwn88QINCwf+DAB3PDLwAAAHFJREFUeJx9ztsOhCAMRdEDrRRQ8Pr/32ohXpBJZj/BSmgBjKUuHgAQO/nkmAp7G9AUrK/sIplXDUVXWTDSdGukEXIxxKdcMCdfbjdjXlgXBF5mtIysC3RsfdMwdIGOxQ9DnsOHn/7xmrauaa9/OPoCTp5BBcWnsnonAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/assets/img/email-i.png
// module id = ../../../../../src/assets/img/email-i.png
// module chunks = main